import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeIconActive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.9979 3.19844C13.2143 1.77157 12.3225 1.05813 11.3335 0.784523C10.4611 0.54318 9.53958 0.54318 8.66716 0.784523C7.67815 1.05813 6.78636 1.77157 5.00277 3.19844L4.04443 3.9651C2.94185 4.84717 2.39056 5.2882 1.99373 5.83563C1.64219 6.32059 1.38064 6.86476 1.22156 7.44223C1.04199 8.09406 1.04199 8.80003 1.04199 10.212V14.6535C1.04199 17.0314 2.96966 18.9591 5.34755 18.9591C6.53649 18.9591 7.50033 17.9953 7.50033 16.8064V13.3341C7.50033 11.9534 8.61958 10.8341 10.0003 10.8341C11.3811 10.8341 12.5003 11.9534 12.5003 13.3341V16.8064C12.5003 17.9953 13.4642 18.9591 14.6531 18.9591C17.031 18.9591 18.9587 17.0314 18.9587 14.6535V10.212C18.9587 8.80003 18.9587 8.09406 18.7791 7.44223C18.62 6.86476 18.3585 6.32059 18.0069 5.83563C17.6101 5.2882 17.0588 4.84717 15.9562 3.9651L14.9979 3.19844Z",
		fill: "currentColor"
	})
});
export default SvgHomeIconActive;
